import {registerPlugin} from "@capacitor/core";

interface TrackActionParams {
    // The action name to track.
    action: string;
}

/**
 * This interface defines a contract for a Capacitor plugin that serves as a bridge between your
 * web-based code and the native mobile code (iOS/Android) used in mobile applications.
 * For more details, see: https://capacitorjs.com/docs/plugins/workflow
 */
interface IAdobeTrackingServiceCapacitorPlugin {
    notifyUserHasChanged(options: {code: string}): void;
    registerPushService(): void;
    // Tracks an action.
    trackAction(params:TrackActionParams): void;
}

/**
 * Capacitor Plugin for communicating with the AdobeTrackingServiceCapacitorPlugin implemented in the native code of the mobile applications
 */
export const AdobeTrackingServiceCapacitorPlugin = registerPlugin<IAdobeTrackingServiceCapacitorPlugin>('AdobeTrackingServicePlugin');